"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const selectors_1 = require("~/store/selectors");
const controls_1 = require("~/components/common/controls");
const UI_1 = require("~/components/UI");
const Address_1 = __importDefault(require("~/components/Account/Address"));
const consts_1 = require("~/consts/consts");
const profileValidation_1 = __importDefault(require("../profileValidation"));
const AdminProfileView_module_scss_1 = __importDefault(require("./AdminProfileView.module.scss"));
function AdminProfileView({ editMode, isSubmitted, submitHandler, disableSubmit }) {
    const { t } = (0, react_i18next_1.useTranslation)('profile');
    const user = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const [firstName, setFirstName] = (0, react_1.useState)();
    const [lastName, setLastName] = (0, react_1.useState)();
    const [phoneNumber, setPhoneNumber] = (0, react_1.useState)({ value: '', error: null });
    const company = consts_1.ADMIN_COMPANY;
    (0, react_1.useEffect)(() => {
        if (isSubmitted) {
            submitHandler({ firstName, lastName, phoneNumber: phoneNumber.value });
        }
    }, [isSubmitted]);
    const phoneInputHandler = (key, value) => {
        setPhoneNumber({ value, error: phoneNumber.error });
    };
    const errors = {
        none: null,
        required: t('errors.phone-number'),
    };
    const phoneErrorHandler = (key, value) => {
        disableSubmit(true);
        setPhoneNumber({ value: phoneNumber.value, error: errors[value] });
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (user) {
            setFirstName(user.firstName);
            setLastName(user.lastName);
            setPhoneNumber({ value: (_a = user.phoneNumber) !== null && _a !== void 0 ? _a : '', error: phoneNumber.error });
        }
    }, [user]);
    (0, react_1.useEffect)(() => {
        disableSubmit((0, profileValidation_1.default)(user, { firstName, lastName, phoneNumber: phoneNumber.value }, phoneNumber.error));
    }, [disableSubmit, firstName, lastName, phoneNumber, user]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: AdminProfileView_module_scss_1.default.section, "data-border": true },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: AdminProfileView_module_scss_1.default.label }, t('info.first-name')),
                editMode ? (react_1.default.createElement(UI_1.Input, { type: "text", maxLength: 60, value: firstName, customErrors: { required: t('errors.first-name') }, onChange: setFirstName, onInput: setFirstName, required: true })) : (react_1.default.createElement("div", null, user === null || user === void 0 ? void 0 : user.firstName))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: AdminProfileView_module_scss_1.default.label }, t('info.last-name')),
                editMode ? (react_1.default.createElement(UI_1.Input, { type: "text", maxLength: 60, value: lastName, customErrors: { required: t('errors.last-name') }, onChange: setLastName, onInput: setLastName, required: true })) : (react_1.default.createElement("div", null, user === null || user === void 0 ? void 0 : user.lastName))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: AdminProfileView_module_scss_1.default.label }, t('info.phone-number')),
                editMode ? (react_1.default.createElement(controls_1.PhoneNumberInput, { state: phoneNumber, inputKey: "phoneNumber", onInput: phoneInputHandler, onError: phoneErrorHandler, required: true })) : (react_1.default.createElement("div", null, !(user === null || user === void 0 ? void 0 : user.phoneNumber) ? '-' : `+${user === null || user === void 0 ? void 0 : user.phoneNumber}`)))),
        react_1.default.createElement("div", { className: AdminProfileView_module_scss_1.default.section },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: AdminProfileView_module_scss_1.default.label }, t('info.company')),
                react_1.default.createElement("div", null, company.companyName)),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: AdminProfileView_module_scss_1.default.label }, t('company.email')),
                react_1.default.createElement("div", null, company.email)),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: AdminProfileView_module_scss_1.default.label }, t('company.phone')),
                react_1.default.createElement("div", null, company.phoneNumber ? react_1.default.createElement("div", null, company.phoneNumber) : null))),
        react_1.default.createElement("div", { className: AdminProfileView_module_scss_1.default.section },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: AdminProfileView_module_scss_1.default.label }, t('company.address')),
                react_1.default.createElement(Address_1.default, { address: Object.assign({}, company.publicAddress) })))));
}
exports.default = AdminProfileView;
